/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function AnnualAndOtherReportsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Reports"
              description={
               <>
               <h4>Annual Reports</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/AnnualAndOtherReports/ENS Annual Report 2026_ENG_FINAL.pdf">Annual Report of the Chief Electoral Officer, April 1, 2025 – March 31, 2026</a></u></li> <br />
                    <li><u><a href="/files/AnnualAndOtherReports/ENS Annual Report 2026_FRE_FINAL.pdf">Rapport Annuel d&#39;Elections Nouvelle-Ecosse, 1er avril 2025 au 31 mars 2026</a></u></li> <br />
                    <li><u><a href="/files/AnnualAndOtherReports/ENS Annual Report 2025_ENG_FINAL_web copy.pdf">Annual Report of the Chief Electoral Officer, April 1, 2024 - March 31, 2025</a></u></li> <br />
                    <li><u><a href="/files/AnnualAndOtherReports/ENS Annual Report 2025_FRE_FINAL.pdf">Rapport Annuel d&#39;Elections Nouvelle-Ecosse, 1er avril 2024 au 31 mars 2025</a></u></li> <br />
                    <li><u><a href="/files/AnnualAndOtherReports/ENS_AnnualReport2024_ENG_FINAL_WEB.pdf">Annual Report of Chief Electoral Officer, April 1, 2023 - March 31, 2024 </a></u></li> <br />
                    <li><u><a href="/files/AnnualAndOtherReports/ENS_AnnualReport2024_FRE_FINAL_WEB.pdf">Rapport Annuel d&#39;Elections Nouvelle-Ecosse, 1er avril 2023 au 31 mars 2024 </a></u></li> <br />
                  </ul>
                  <br />
                  <h4>Other Reports</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/AnnualAndOtherReports/ERUpdateReport_FINAL_Oct2026.pdf">Election Readiness Update - October 2026</a></u></li>
                    <li><u><a href="/files/AnnualAndOtherReports/2026_2030_ENS_Strategic_Plan_FINAL.pdf">Elections Nova Scotia four-year Strategic Plan 2026-2030</a></u></li>
                    <li><u><a href="/files/AnnualAndOtherReports/ENS_StrategicPlan_2022_2026.pdf">Elections Nova Scotia four-year Strategic Plan 2022-2026</a></u></li>
                    <li><u><a href="/files/AnnualAndOtherReports/OutreachStrategyActionPlan_IDEAs_FINAL.pdf">Elections Nova Scotia&#39;s Outreach Action Plan</a></u></li>
                    <li><u><a href="/files/AnnualAndOtherReports/ENS_2026-2027_BudgetEstimates_FINAL.pdf">2026-2027 Budget Estimates as presented to the Special Committee of the House of Assembly on January 14, 2026</a></u></li><br />                    
                  </ul>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AnnualAndOtherReportsInformation;
